module.exports = __webpack_public_path__ + "assets/img/media_6.c6f5a52f.png";